"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeFilter = exports.nativeFilterResultSchema = exports.nativeFilterArgsSchema = exports.filterOperatorSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Filter operator enum
exports.filterOperatorSchema = zod_1.z.enum([
    'equals',
    'not_equals',
    'contains',
    'not_contains',
    'greater_than',
    'less_than',
    'greater_than_or_equal',
    'less_than_or_equal',
    'in',
    'not_in',
    'unique',
    'distinct_by',
]);
// Argument schema
exports.nativeFilterArgsSchema = zod_1.z.object({
    array: zod_1.z.array(zod_1.z.any()).describe('The array to filter'),
    path: zod_1.z
        .string()
        .describe('The path to the property within each item to compare. If empty, filters primitives directly.'),
    operator: exports.filterOperatorSchema.describe('The comparison operator to use for filtering'),
    value: zod_1.z
        .any()
        .describe('The value to compare against. For "in" and "not_in" operators, this should be an array. Not required for "unique" operator.'),
    offset: zod_1.z
        .number()
        .min(0)
        .nullish()
        .describe('Number of items to skip from the beginning of the filtered results (for pagination)'),
    limit: zod_1.z
        .number()
        .min(1)
        .nullish()
        .describe('Maximum number of items to return from the filtered results (for pagination)'),
    outputSchema: zod_1.z
        .string()
        .describe('The schema for the output array as a JSON Schema. If T is the type of the object, the output schema should be {"type": "object", "properties": { "filteredArray": {"type": "array", "items": {"type": "T"}}}}'),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.nativeFilterResultSchema = zod_1.z.object({
    filteredArray: zod_1.z.array(zod_1.z.any()).describe('The filtered array'),
});
// Tool definition
exports.nativeFilter = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeFilter',
    displayName: 'Filter Array',
    displayDescription: 'Filter array items based on conditions or remove duplicates. Supports comparison operators (equals, contains, greater_than, etc.), deduplication (unique, distinct_by), and pagination with offset/limit. DEDUPLICATION USAGE: Use "unique" operator to remove all duplicates from arrays. Use "distinct_by" operator with a path to remove duplicates based on a specific field (e.g., path: "email" to dedupe by email field). For CSV data, use distinct_by with column names. Examples: Remove duplicate URLs from array, deduplicate CSV rows by ID field, remove duplicate objects entirely.',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'filter',
    argsSchema: exports.nativeFilterArgsSchema,
}, exports.nativeFilterResultSchema);
